import Emitter from 'Emitter';
import {
    BoundAuthorisationActions,
    BoundAuthorisationSelectors,
} from 'reactApp/modules/AuthorisationModule';
import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

export class McsUserApi extends Emitter {
    identify() {
        return BoundAuthorisationActions.checkAuthorisation();
    }

    isAuthorized() {
        return BoundAuthorisationSelectors.getIsAuthorised();
    }

    getEmail() {
        return BoundCurrentUserSelectors.getEmail();
    }
}
